"use client";
import { jsxs as w, jsx as p } from "react/jsx-runtime";
import { createContext as D, useRef as T, useState as k, useEffect as y, useContext as v } from "react";
import { classNames as u } from "../../utilities/index.js";
const g = D(null), b = ({ variant: n = "floating", hasBackdrop: f, backdropClass: s, className: i, children: a, onClose: t, showCaret: e, ...c }) => {
  const r = T(null), [o, l] = k(!1), d = () => {
    l(!o), o && typeof t == "function" && t();
  };
  y(() => (document.addEventListener("click", h), () => document.removeEventListener("click", h)), []);
  const h = (m) => {
    m.target && (r != null && r.current) && !r.current.contains(m.target) && (l(!1), typeof t == "function" && t());
  };
  return /* @__PURE__ */ w(g.Provider, { value: { isOpen: o, onTriggerClick: d, variant: n, showCaret: e }, children: [
    /* @__PURE__ */ p(
      "div",
      {
        ref: r,
        className: `sash-Dropdown relative ${i || ""}`,
        ...c,
        children: a
      }
    ),
    f && o && /* @__PURE__ */ p("div", { className: `sash-DropdownBackdrop ${s || ""}` })
  ] });
}, C = ({ className: n, children: f, activeClass: s, caretClass: i, onClick: a, ...t }) => {
  const { isOpen: e, onTriggerClick: c, showCaret: r, variant: o } = v(g), l = u({
    "sash-DropdownTrigger flex flex-wrap items-center relative [&_svg]:pointer-events-none": !0,
    [`sash-DropdownTrigger--active ${s}`]: e,
    [n]: n
  }), d = u({
    'sash-DropdownTriggerCaret absolute z-2 left-1/2 top-full -translate-x-1/2 before:content-[""] before:border-8 before:border-transparent before:border-b-gray-25 before:absolute before:left-0 before:top-0 after:content-[""] after:border-8 after:border-transparent after:border-b-white after:absolute after:left-0 after:top-px': !0,
    [i]: i
  });
  return /* @__PURE__ */ w(
    "button",
    {
      onClick: () => {
        c(), a && typeof a == "function" && a();
      },
      className: l,
      "aria-haspopup": "true",
      "aria-expanded": e,
      type: "button",
      ...t,
      children: [
        f,
        e && r && o === "floating" && /* @__PURE__ */ p("span", { className: d })
      ]
    }
  );
}, x = ({ className: n, children: f, position: s = "left", closeOnContentClick: i, ...a }) => {
  const { isOpen: t, variant: e, showCaret: c, onTriggerClick: r } = v(g), o = i ? { onClick: r } : {}, l = u({
    "sash-DropdownContent": !0,
    "absolute bg-white border border-gray-15 p-3": e === "floating",
    "left-0": e === "floating" && s === "left",
    "right-0": e === "floating" && s === "right",
    block: t,
    hidden: !t,
    "sash-DropdownContent-hasCaret top-[calc(100%+15px)]": c && e === "floating",
    "top-full": !c && e === "floating",
    [n]: n
  });
  return /* @__PURE__ */ p(
    "div",
    {
      className: l,
      "aria-hidden": !t,
      ...o,
      ...a,
      children: f
    }
  );
};
b.Trigger = C;
b.Content = x;
C.displayName = "Dropdown.Trigger";
x.displayName = "Dropdown.Content";
const E = b;
export {
  E as default
};
